/**
 * Send message to host
 */

import { screenLog } from 'components/ScreenLog/index.jsx';

function webViewMessage(data) {
  const dataString = JSON.stringify(data);
  if (typeof window.webkit !== 'undefined' && window.webkit.messageHandlers) {
    // iOS
    screenLog('send route message to iOS', dataString);
    window.webkit.messageHandlers.route.postMessage(data);
    return;
  }
  if (typeof window.authBridge !== 'undefined') {
    // Android
    screenLog('send route message to Android', dataString);
    const { route, routeArgs } = data;
    window.routeBridge.performRoute(route, JSON.stringify(routeArgs));
    return;
  }
  screenLog('ignore send route message', dataString);
}

export default webViewMessage;
